import React, { useMemo } from 'react';
import { Wrapper, StyledMedia } from './style';
import { FaFileAlt } from 'react-icons/fa';

export const FlexMediaPreviewerV2 = ({ fileURL }) => {
  const url = useMemo(() => normalizeUrl(fileURL), [fileURL]);
  const mediaType = useMemo(() => getTypeFromUrl(fileURL), [fileURL]);

  if (!url) return <div>Nenhum arquivo selecionado</div>;

  return (
    <Wrapper>
      {mediaType === 'IMAGE' && <StyledMedia as="img" src={url} alt="Imagem" />}
      {mediaType === 'AUDIO' && <StyledMedia as="audio" controls src={url} />}
      {mediaType === 'VIDEO' && <StyledMedia as="video" controls src={url} />}
      {(mediaType === 'FILE' || mediaType === 'DOCUMENTS') && (
        <a
          href={url}
          download
          target="_blank"
          rel="noopener noreferrer"
          style={{
            wordBreak: 'break-word',
            textDecoration: 'underline',
            color: '#0056b3',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          <FaFileAlt size="16" color="#6A5ACD" />
          Baixar arquivo
        </a>
      )}
    </Wrapper>
  );
};

function getTypeFromUrl(url) {
  if (!url) return 'FILE';
  const extension = url.split('.').pop().toLowerCase();

  if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(extension))
    return 'IMAGE';
  if (['mp3', 'wav', 'ogg', 'mpeg', 'aac', 'mp4', 'x-m4a'].includes(extension))
    return 'AUDIO';
  if (['mp4', 'webm', 'mov'].includes(extension)) return 'VIDEO';
  if (['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(extension))
    return 'DOCUMENTS';

  return 'FILE';
}

function normalizeUrl(url) {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('blob')) return url;

  return `${window.location.origin}/${url.replace(/^\/+/, '')}`;
}
